var render = function render(){var _vm=this,_c=_vm._self._c;return _c('float-input',_vm._g(_vm._b({attrs:{"type":"date","max":"9999-12-31","value":_vm.inputValue},on:{"input":_vm.input}},'float-input',_vm.$attrs,false),_vm.xListeners(['input'])))
}
var staticRenderFns = []

export { render, staticRenderFns }